import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'tipoinmuebles',
  getAllParams: ({ page, perPage, search }) => ({
    'filter[nombre]': search,
    page,
    per_page: perPage,
  }),
});
